import React, { Component } from 'react';
import events from '../../../services/events';
import { connect } from 'react-redux';
import * as sideBarActions from '../../../redux/sideBarActions';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import { bindActionCreators } from 'redux';
import { Popover } from 'reactstrap';
import DesignDescription from '../../../components/InfoPanels/DesignDescription/DesignDescription';
import '../SideBarContainer.scss';
import * as Constants from '../../../utilities/constants/Constants';
import {
  getFolderListElementStyle,
  currencyPlacing
} from './ElementListTemplate';
import FolderAuthentication from '../../../components/PopupWindows/FolderAuthentication/FolderAuthentication';
import { currencyConversion } from '../../../utilities/HelperFunctions/HelperFunctions';

class ElementFolderListTemplate extends Component {
  state = {
    activeItem: null,
    contentItem: null,
    showAuthenticationWindow: false
  };

  componentWillUnmount() {
    const { activeItem } = this.state;
    this.resetItem(activeItem);
  }

  localAddToCanvas = item => {
    const { addToCanvas } = this.props;
    addToCanvas(item);
  };

  toggleInfoPanel = item => {
    const { activeItem } = this.state;
    if (activeItem !== null) {
      if (this.getUniqueId(item) !== this.getUniqueId(activeItem)) {
        item.showPriceTag = !item.showPriceTag;
      }
    } else {
      item.showPriceTag = true;
    }
    item.popoverOpen = !item.popoverOpen;
    this.setState({ activeItem: item });
  };

  resetItem = item => {
    const { activeItem } = this.state;
    if (activeItem !== null) {
      item.showPriceTag = false;
      item.popoverOpen = false;
    }
  };

  handleUnclockClick = item => {
    this.setState({ contentItem: item });
    this.authenticationWindowHandler(true);
  };

  authenticationWindowHandler = state => {
    this.setState({ showAuthenticationWindow: state });
  };

  setElememtBackgroundSize = theme => {
    const { activeTab } = this.props;
    if (activeTab === Constants.BACKGROUND_TAB_KEY) {
      return 'cover';
    }
    if (theme === 'Lines') return '400%';
    return 'contain';
  };

  getUniqueId = item => {
    if (item.id) {
      return item.id;
    }
    return item.mediaId;
  };

  render() {
    const {
      activeTab,
      data: subTheme,
      showPlaceablesName,
      language,
      storeData,
      dispatchers
    } = this.props;
    const { activeItem, showAuthenticationWindow, contentItem } = this.state;

    let infoVisibility = 'hidden';
    if (
      Object.prototype.hasOwnProperty.call(subTheme, 'isPremium') &&
      subTheme.isPremium
    ) {
      infoVisibility = 'visible';
    }

    let showGoInside = false;

    const goInside = (
      <div
        role='button'
        tabIndex='0'
        className='image-wraper'
        onKeyPress={() => {}}
        onClick={e => {
          e.stopPropagation();
          dispatchers.sideBarActions.getFolderListElements(subTheme);
        }}
      >
        <div className='folder-list-element folder-inside-box' />
      </div>
    );
    if (
      subTheme.themes.length > 0 ||
      Object.prototype.hasOwnProperty.call(subTheme, 'sampleContents') ||
      Object.prototype.hasOwnProperty.call(subTheme, 'samplePatterns')
    ) {
      showGoInside = true;
    }
    let items = [];
    if (Object.prototype.hasOwnProperty.call(subTheme, 'samplePatterns')) {
      items = [...subTheme.samplePatterns];
    } else if (
      Object.prototype.hasOwnProperty.call(subTheme, 'sampleContents')
    ) {
      items = [...subTheme.sampleContents];
    } else {
      items = [...subTheme.elements];
    }
    if (items.length > 9) {
      items = items.splice(0, 8);
      showGoInside = true;
    }

    items.forEach(item => {
      if (
        activeItem !== null &&
        this.getUniqueId(item) !== this.getUniqueId(activeItem)
      ) {
        item.popoverOpen = false;
        item.showPriceTag = false;
      }
    });

    return (
      <div>
        <div className='elements-title'>
          <div>
            {Object.prototype.hasOwnProperty.call(subTheme, 'locNames') &&
            subTheme.locNames
              ? subTheme.locNames[language]
              : subTheme.name}
          </div>

          {subTheme.needsAuthenetication ? (
            <button
              type='button'
              alt='lock'
              className='lock-icon'
              onClick={() => this.handleUnclockClick(subTheme)}
            />
          ) : null}
        </div>
        {!subTheme.needsAuthenetication ? (
          <div className='folder-display'>
            {items.map(item => (
              <div className='image-wraper' key={this.getUniqueId(item)}>
                <div
                  role='button'
                  tabIndex='0'
                  id={activeTab + item.imageSource + this.getUniqueId(item)}
                  className={getFolderListElementStyle(activeTab)}
                  style={{
                    backgroundImage:
                      activeTab === Constants.BACKGROUND_TAB_KEY
                        ? `url(${item.thumbnailPath})`
                        : null,
                    backgroundSize: this.setElememtBackgroundSize(subTheme.name)
                  }}
                  onKeyPress={() => {}}
                  onClick={() => {
                    dispatchers.fabricCanvasActions.addToCanvas(item);
                  }}
                  {...(activeTab === Constants.ELEMENT_TAB_KEY ||
                  activeTab === Constants.PHOTO_TAB_KEY
                    ? {
                        draggable: 'true',
                        onDragStart: e => {
                          events.onDragStart(
                            e,
                            item,
                            dispatchers.fabricCanvasActions.addToCanvas
                          );
                        },
                        onDragEnd: e => {
                          events.onDragEnd(e, item);
                        }
                      }
                    : {})}
                >
                  {activeTab !== Constants.BACKGROUND_TAB_KEY ? (
                    <div
                      className='inner-elemet'
                      style={{
                        backgroundImage: `url(${item.thumbnailPath})`,
                        backgroundSize: this.setElememtBackgroundSize(
                          subTheme.name
                        )
                      }}
                    />
                  ) : null}
                  <div
                    className={`hover-layer-folder ${
                      activeTab !== Constants.BACKGROUND_TAB_KEY
                        ? 'element-border'
                        : null
                    }`}
                  />

                  <div
                    role='button'
                    tabIndex='0'
                    style={{ visibility: infoVisibility }}
                    className='info-icon'
                    onKeyPress={() => {}}
                    onClick={e => {
                      if (e.stopPropagation) e.stopPropagation();
                      dispatchers.sideBarActions.patternInfoClicked(item);
                      this.toggleInfoPanel(item);
                      dispatchers.sideBarActions.patternDesignCost(item);
                    }}
                  >
                    <Popover
                      placement='bottom'
                      isOpen={item.popoverOpen}
                      target={
                        activeTab + item.imageSource + this.getUniqueId(item)
                      }
                    >
                      <DesignDescription
                        data={item}
                        onClose={() => this.toggleInfoPanel(item)}
                      />
                    </Popover>
                  </div>

                  {item.showPriceTag &&
                  item.imageSource !== Constants.UNSPLASH_IMAGE_SOURCE ? (
                    <div
                      className={currencyPlacing(storeData.placeMsrpCurrency)}
                    >
                      <div>
                        {item.costValue
                          ? currencyConversion(
                              item,
                              storeData.conversionUnitEur,
                              storeData.conversionUnitUsd
                            ).toFixed(2)
                          : null}
                      </div>

                      <div>{storeData.msrpCurrency}</div>
                    </div>
                  ) : null}
                </div>
                {showPlaceablesName &&
                item.imageSource !== Constants.PATTERN_DESIGN_IMAGE_SOURCE &&
                item.imageSource !== Constants.DREAMSTIME_IMAGE_SOURCE &&
                item.imageSource !== Constants.UNSPLASH_IMAGE_SOURCE &&
                item.imageSource !== Constants.VECTEEZY_IMAGE_SOURCE &&
                item.imageSource !== Constants.ADOBE_STOCK_IMAGE_SOURCE &&
                item.imageSource !== Constants.GETTY_IMAGE_SOURCE &&
                item.imageSource !== Constants.I_STOCK_IMAGE_SOURCE &&
                item.imageSource !== Constants.HP_MOSAIC_IMAGE_SOURCE ? (
                  <div className='bg-obj-name'>
                    {item.name
                      ? item.name.charAt(0).toUpperCase() + item.name.slice(1)
                      : null}
                  </div>
                ) : null}
              </div>
            ))}
            {showGoInside ? goInside : null}
          </div>
        ) : null}

        {showAuthenticationWindow ? (
          <FolderAuthentication
            item={contentItem}
            isSubtheme
            isOpen={showAuthenticationWindow}
            authenticationWindowHandler={this.authenticationWindowHandler}
          />
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeTab: state.sideBar.activeSideBarTab,
    patternDataIsAvailable: state.sideBar.pattrenDataIsAvilable,
    showPlaceablesName: state.modal.storeData.showPlaceablesName,
    language: state.home.language,
    triggerRedraw: state.sideBar.triggerRedraw,
    storeData: state.modal.storeData,
    showSideBar: state.sideBar.showSideBar
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch)
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ElementFolderListTemplate);
